<template>
  <price :value="fees" class="error--text"></price>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Purchase from '@/api/purchase'
  import { Price } from '@/components/formatters'
  import purchase from '@/mixins/purchase'
  export default {
    components: {
      Price
    },
    mixins: [purchase],
    computed: {
      ...mapGetters({
        platform: 'skiliko/session/currentPlatform',
        currentUser: 'skiliko/session/currentUser'
      }),
      fees () { return Purchase.fees(this.purchase, this.platform, this.currentUser) * -1 }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/purchase/Fees.vue